import {
  createFleet,
  disableFleets,
  enableFleets,
  fetchFleetsForService,
  retrieveVendorDetails,
  updateVendorLogo,
  updateVendorLogoScale,
  updateVendorName,
  updateVendorServiceIds,
  updateVendorSlogan,
  updateVendorUrl,
} from "@/ServerActions/companies";
import { ApiResponse, DataResponse, FleetRes } from "@/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useFleets = () => {
  return useQuery<ApiResponse<FleetRes[]>>({
    queryKey: ["fleet-list", "DotAdmin"], // ✅ FIXED
    queryFn: () => fetchFleetsForService(),
    staleTime: 300000,
  });
};

export const useVendorDetails = (
  id: string,
  options?: { enabled?: boolean }
) => {
  return useQuery<DataResponse<FleetRes>>({
    queryKey: ["vendor-details", "DotAdmin", id],
    queryFn: () => retrieveVendorDetails({ vendor_id: id }),
    staleTime: 0,
    enabled: options?.enabled ?? true, // fallback safety
  });
};

export const useCreateFleet = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: createFleet,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["fleet-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useDisableFleet = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: disableFleets,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["fleet-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useEnableFleet = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: enableFleets,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["fleet-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateLogo = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateVendorLogo,
    onSuccess: (_data, variables) => {
      const vendorId = variables?.vendor_id;

      queryClient.invalidateQueries({
        queryKey: ["vendor-details", "DotAdmin", vendorId],
      });

      queryClient.invalidateQueries({
        queryKey: ["fleet-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateName = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateVendorName,
    onSuccess: (_data, variables) => {
      const vendorId = variables?.vendor_id;

      queryClient.invalidateQueries({
        queryKey: ["vendor-details", "DotAdmin", vendorId],
      });

      queryClient.invalidateQueries({
        queryKey: ["fleet-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateSlogan = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateVendorSlogan,
    onSuccess: (_data, variables) => {
      const vendorId = variables?.vendor_id;

      queryClient.invalidateQueries({
        queryKey: ["vendor-details", "DotAdmin", vendorId],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateUrl = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateVendorUrl,
    onSuccess: (_data, variables) => {
      const vendorId = variables?.vendor_id;

      queryClient.invalidateQueries({
        queryKey: ["vendor-details", "DotAdmin", vendorId],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const updateLogoScale = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateVendorLogoScale,
    onSuccess: (_data, variables) => {
      const vendorId = variables?.vendor_id;

      queryClient.invalidateQueries({
        queryKey: ["vendor-details", "DotAdmin", vendorId],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const updateServiceIds = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateVendorServiceIds,
    onSuccess: (_data, variables) => {
      const vendorId = variables?.vendor_id;

      queryClient.invalidateQueries({
        queryKey: ["vendor-details", "DotAdmin", vendorId],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};
